// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import FormDialog from '../../../components/Dialog/FormDialog';
import TextInput from '../../../components/Form/TextInput';
import { useRequestEndInvestorOnboarding } from '../../../hooks/mutations/registry/onboarding/useRequestEndInvestorOnboarding';

type DialogProps = {
  open: boolean;
  onClose: () => void;
  participantServiceContractId: string;
  participant: string;
};

export const OfferEndInvestorOnboardingDialog = ({
  open,
  onClose,
  participantServiceContractId,
  participant,
}: DialogProps) => {
  const [endInvestor, setEndInvestor] = useState<string>('');
  const [upgrader, setUpgrader] = useState<string>('');

  const handleClose = useCallback(() => {
    setEndInvestor('');
    setUpgrader('');
    onClose();
  }, [onClose]);

  const requestEndInvestorOnboarding = useRequestEndInvestorOnboarding();

  const onboard = useCallback(async () => {
    await requestEndInvestorOnboarding({
      participantServiceContractId,
      participantId: participant,
      endInvestorId: endInvestor,
      upgrader,
    });

    handleClose();
  }, [
    requestEndInvestorOnboarding,
    participant,
    participantServiceContractId,
    endInvestor,
    upgrader,
    handleClose,
  ]);

  const disableSubmit = endInvestor === '' || !upgrader;

  return (
    <FormDialog
      open={open}
      title="Request End Investor Onboarding"
      onCancel={handleClose}
      onSubmit={onboard}
      submitName="Onboard"
      isSubmitDisabled={disableSubmit}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextInput
          enableTopLabel
          label="End Investor Party ID"
          value={endInvestor}
          setValue={setEndInvestor}
        />
        <TextInput
          enableTopLabel
          label="Upgrader Party ID"
          value={upgrader}
          setValue={setUpgrader}
        />
      </Box>
    </FormDialog>
  );
};
